<div
  class="full-page w-100 d-flex px-0"
  [style.background-image]="'url(' + ('login-registration/login-background.jpg' | contentAssetImage) + ')'"
>
  <!--Left Side-->
  <div class="container">
    <img [src]="'logos/rewards-logo.png' | contentAssetImage" alt="" class="logo" />
    <!--Right Side-->
    <div class="right-side-login">
      <h4 class="text-primary panel-text font-size-20 fw-bold text-white">
        {{ 'login.page.title' | translate }}
      </h4>
      <div class="font-size-14 text-start description-two text-center">
        {{ 'login.page.description' | translate }}
      </div>
      <fgb-sales-force-user-login></fgb-sales-force-user-login>

      <ng-container *ngIf="errorCode$ | async as errorCode">
        <div
          class="text-white text-center mt-2 fw-bold error-text-login"
          [innerHTML]="errorCode | translate | markdownTranslate"
        ></div>
      </ng-container>
    </div>
  </div>
</div>

<fgbcl-preview />
